/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivContractViewModelGen,
  MrfiktivFleetContractControllerGetAllParamsGen,
  MrfiktivFleetContractControllerGetAllPostParamsGen,
  MrfiktivMultipleIdsDtoOptionalGen,
  MrfiktivPageViewModelGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class FleetContracts<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags Fleet Contracts
   * @name FleetContractControllerGetAll
   * @summary (FLEET-CONTRACT-READ) Get all contracts for the fleet
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/contract
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivContractViewModelGen)[] })`
   */
  fleetContractControllerGetAll = (
    { partnerId, fleetId, ...query }: MrfiktivFleetContractControllerGetAllParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivContractViewModelGen[] }, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/contract`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Contracts
   * @name FleetContractControllerGetAllPost
   * @summary (FLEET-CONTRACT-READ) Get all contracts for the fleet
   * @request POST:/partner/{partnerId}/fleet/{fleetId}/contract
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivContractViewModelGen)[] })`
   */
  fleetContractControllerGetAllPost = (
    { partnerId, fleetId, ...query }: MrfiktivFleetContractControllerGetAllPostParamsGen,
    data: MrfiktivMultipleIdsDtoOptionalGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivContractViewModelGen[] }, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/contract`,
      method: "POST",
      query: query,
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags Fleet Contracts
   * @name FleetContractControllerGetOne
   * @summary (FLEET-CONTRACT-READ) Get a single contract by contractId
   * @request GET:/partner/{partnerId}/fleet/{fleetId}/contract/{contractId}
   * @secure
   * @response `200` `MrfiktivContractViewModelGen` The contract
   */
  fleetContractControllerGetOne = (
    partnerId: string,
    fleetId: string,
    contractId: string,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivContractViewModelGen, any>({
      path: `/partner/${partnerId}/fleet/${fleetId}/contract/${contractId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
}
